// @flow
import React from 'react';

import ReactResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { MemberNav } from 'Components/widgets/member-nav/MemberNav.jsx';

type Props = {
  cmsAccount: CMSAccount,
  cmsMemberSpace: CMSMemberSpace,
  userInfo?: UserInfo,
};

function getUserInfo(userInfo = {}) {
  const res: UserInfoSummary = {
    firstName: userInfo.unicodeFirstName || userInfo.firstName,
    lastName: userInfo.unicodeLastName || userInfo.lastName,
    isLoggedIn: !!userInfo.isLoggedIn,
    isQuickLoggedIn: !!userInfo.isQuickLoggedIn,
  };

  return res;
}

export const NavigationMemberAccess = (props: Props) => {
  const responsiveContext = React.useContext(ReactResponsiveContext);

  if (!responsiveContext.isAppMounted) {
    return null;
  }

  const { cmsAccount, cmsMemberSpace = {}, userInfo } = props;
  const userInfos = getUserInfo(userInfo);

  const welcomeLabelTemplate = cmsMemberSpace.accessButtonLoggedin;

  return (
    <MemberNav
      userInfo={userInfos}
      cmsContent={{
        welcomeLabelTemplate,
        title: cmsMemberSpace.title,
        navigationSections: cmsMemberSpace.navigationSections,
        account: cmsAccount,
      }}
    />
  );
};
